import posthog from 'posthog-js';
import { environment } from './environments/environment';

const posthogConfig = (environment as any).posthog as { apiKey?: string; apiHost?: string } | undefined;

if (typeof window !== 'undefined' && posthogConfig?.apiKey) {
    posthog.init(posthogConfig.apiKey, {
        api_host: posthogConfig.apiHost,
    });
}
